import React from 'react';

import { Button } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { addAccountUrl } from '../../../Shared/addAccountUrl';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { CreateAccountRecommendationMutation } from '../graphql/mutation.createAccountRecommendation.generated';

type MutationResult = CreateAccountRecommendationMutation['createAccountRecommendation']['result'];
type Option = NonNullable<MutationResult>['productOnboardingOption'];

export const OpenAccountButton: React.FC<{ option: Option; isEnabled: boolean }> = ({ option, isEnabled }) => {
  const linkDetails = (() => {
    if (option.__typename === 'GoalCreationOption') {
      const url = addAccountUrl({ product_category: option.legacyProductCategory });
      return { url, text: 'Open this account' };
    }

    if (option.__typename === 'CheckingAccountCreationOption') {
      return { url: urlBuilder.getAppCheckingAbout.absolute(), text: 'Open this account' };
    }

    if (option.__typename === 'Solo401kOnboardingOption') {
      const pc = option.legacyProductCategory;
      const url = urlBuilder.appAdviceInitiationFlow.absolute({ signup_intent: pc, product_category: pc });
      return { url, text: 'Get started' };
    }

    return null;
  })();

  if (!linkDetails) return null;

  return (
    <SambaAutoLink to={linkDetails.url}>
      <Button variant="solidPrimary" disabled={!isEnabled}>
        {linkDetails.text}
      </Button>
    </SambaAutoLink>
  );
};
